import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53743)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1383 41.3792H0.862596C0.386523 41.3792 0.000488281 40.9932 0.000488281 40.5171V9.48271C0.000488281 9.00664 0.386523 8.62061 0.862596 8.62061H49.1384C49.6145 8.62061 50.0005 9.00664 50.0005 9.48271V40.5171C50.0004 40.9933 49.6144 41.3792 49.1383 41.3792Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0005 25H49.1383C49.6144 25 50.0004 24.6139 50.0004 24.1379V9.48271C50.0004 9.00664 49.6144 8.62061 49.1383 8.62061H25.8626C25.3865 8.62061 25.0005 9.00664 25.0005 9.48271V25Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.863573 41.3798H24.1394C24.6155 41.3798 25.0015 40.9937 25.0015 40.5176V25.0005H0.863573C0.387499 25.0005 0.00146484 25.3865 0.00146484 25.8626V40.5177C0.00146484 40.9938 0.387499 41.3798 0.863573 41.3798Z",
					fill: "#4173CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.8335 13.1338L13.6554 15.5981L16.253 15.6182C16.5894 15.6207 16.7288 16.05 16.4582 16.2497L14.3686 17.7928L15.1521 20.2695C15.2534 20.5902 14.8884 20.8554 14.6147 20.6599L12.5015 19.1494L10.3881 20.66C10.1145 20.8556 9.74943 20.5902 9.85079 20.2696L10.6343 17.7929L8.54464 16.2498C8.27404 16.05 8.41349 15.6208 8.74982 15.6183L11.3475 15.5982L12.1693 13.1339C12.2758 12.8148 12.7272 12.8148 12.8335 13.1338Z",
					fill: "#4173CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37.8325 29.5127L38.6544 31.977L41.252 31.9971C41.5884 31.9996 41.7278 32.4289 41.4572 32.6286L39.3676 34.1717L40.1511 36.6484C40.2524 36.9691 39.8874 37.2343 39.6138 37.0388L37.5005 35.5283L35.3871 37.0389C35.1135 37.2345 34.7484 36.9691 34.8498 36.6485L35.6333 34.1718L33.5437 32.6287C33.2731 32.4289 33.4125 31.9997 33.7488 31.9972L36.3465 31.9771L37.1684 29.5128C37.2748 29.1937 37.7262 29.1937 37.8325 29.5127Z",
					fill: "#CD343C"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53743",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgPaFlag);
export { ForwardRef as ReactComponent };
